import api from './api';

export const getServiceReportsByProject = async (projectId) => {
    const res = await api.get(`/ServiceReport/project/${projectId}`);
    return res.data;
};

/** The technician's booked days on the project in the period, one visit per day. */
export const getBookedVisits = async (projectId, { technicianId, startDate, endDate }) => {
    const res = await api.get(`/ServiceReport/project/${projectId}/booked`, {
        params: { technician_id: technicianId, start_date: startDate, end_date: endDate },
    });
    return res.data;
};

export const createServiceReport = async (payload) => {
    const res = await api.post('/ServiceReport', payload);
    return res.data;
};

export const updateServiceReport = async (reportId, payload) => {
    const res = await api.patch(`/ServiceReport/${reportId}`, payload);
    return res.data;
};

export const deleteServiceReport = async (reportId) => {
    const res = await api.delete(`/ServiceReport/${reportId}`);
    return res.data;
};

// Blobs, not URLs: a tab navigation cannot send X-API-Key (see utils/pdfTab.js).
export const getServiceReportPdf = async (reportId) => {
    const res = await api.get(`/ServiceReport/${reportId}/pdf`, { responseType: 'blob' });
    return res.data;
};

export const uploadSignedServiceReport = async (reportId, file) => {
    const body = new FormData();
    body.append('file', file);
    const res = await api.post(`/ServiceReport/${reportId}/signed`, body);
    return res.data;
};

export const getSignedServiceReport = async (reportId) => {
    const res = await api.get(`/ServiceReport/${reportId}/signed`, { responseType: 'blob' });
    return res.data;
};

export const deleteSignedServiceReport = async (reportId) => {
    const res = await api.delete(`/ServiceReport/${reportId}/signed`);
    return res.data;
};
